import { Injectable } from "@angular/core";

@Injectable()
export class ExportToCSVService{
    exportToCsv(data:any[],fileName:string){
        if(!data || data.length==0){
            return;
        }
        const headers= Object.keys(data[0]);
        const csvRows:string[]=data.map((row)=>{
            return headers.map(header=>JSON.stringify(row[header],(key,value)=>{
                return (value===null || value===undefined )?"":value
            })).join(',')
        })
        csvRows.unshift(headers.join(','))
        const csvData=csvRows.join('\n');

        const blob=new Blob([csvData],{type:'text/csv;charset=utf-8;'});
        const url=window.URL.createObjectURL(blob);

        const dummyTag=document.createElement('a');
        dummyTag.href=url;
        dummyTag.download=`${fileName}.csv`
        dummyTag.click();
        dummyTag.remove();
        window.URL.revokeObjectURL(url);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/ExportToCSVService.ts